import { Button, Typography } from "@mui/material";
import { SessionStatus } from "protos/veselka/prediction_point";
import { SMALL_WHITE_BUTTON } from "portal/theme/theme";
import { titleCase } from "portal/utils/strings";
import { useTranslation } from "react-i18next";
import React, { FunctionComponent } from "react";

interface LoadMoreImagesButtonProps {
  isInitialRequestLoading: boolean;
  canLoadMore: boolean;
  disabled?: boolean;
  sessionStatus?: SessionStatus;
  areFilterResultsIncomplete: boolean;
  onLoadMore: () => void;
  onRefresh: () => void;
}
export const LoadMoreImagesButton: FunctionComponent<
  LoadMoreImagesButtonProps
> = ({
  isInitialRequestLoading,
  canLoadMore,
  disabled = false,
  sessionStatus,
  areFilterResultsIncomplete,
  onLoadMore,
  onRefresh,
}) => {
  const { t } = useTranslation();
  if (isInitialRequestLoading) {
    return (
      <Typography className="italic">
        {titleCase(t("components.Loading.placeholder"))}
      </Typography>
    );
  }
  if (canLoadMore) {
    return (
      <Button onClick={onLoadMore} disabled={disabled}>
        {titleCase(t("utils.lists.loadMore"))}...
      </Button>
    );
  }
  const notDone = Boolean(
    sessionStatus && sessionStatus.countOfResults < sessionStatus.expectedCount
  );
  if (notDone || areFilterResultsIncomplete) {
    return (
      <div className="flex items-center gap-4">
        {sessionStatus && notDone ? (
          <Typography>
            {t("components.categoryCollectionProfile.session.notDone", {
              processed: sessionStatus.countOfResults,
              total: sessionStatus.expectedCount,
            })}
          </Typography>
        ) : (
          areFilterResultsIncomplete && (
            <Typography>
              {t(
                "components.categoryCollectionProfile.session.incompleteResults"
              )}
            </Typography>
          )
        )}
        <Button {...SMALL_WHITE_BUTTON} onClick={onRefresh}>
          {t("utils.actions.retry")}
        </Button>
      </div>
    );
  }

  return (
    <Typography className="italic">
      {titleCase(t("utils.lists.noMoreResults"))}
    </Typography>
  );
};
